import { createFileRoute } from '@tanstack/react-router'

import { RouteModal } from '@/components/route-modal'

import { CreateBusinessCardForm } from './-create-form'

export const Route = createFileRoute('/_authenticated/_general/business-cards/create')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.BusinessCards.CreateTitle()
	}
})

function RouteComponent() {
	return (
		<RouteModal asDrawer>
			<CreateBusinessCardForm />
		</RouteModal>
	)
}
